import { Box } from "@material-ui/core"
import { RecallData } from "api/delek"
import styled from "styled-components"
import { ContentItemType } from "typings/contentPage"

const StyledResponse = styled(Box)<{ $columns: number }>`
  display: grid;
  grid-template-columns: ${({ $columns }) => `repeat(${$columns},1fr)`};
  grid-gap: 35px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
`

const StyledItem = styled(Box)<{ $hasBorder: boolean }>`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 35px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }
`
const StyledTextContainer = styled(Box)`
  ${(p) => p.theme.breakpoints.down("sm")} {
    display: flex;
    grid-gap: 13px;
  }
`

const StyledTopText = styled.p`
  margin: 0;
  font-family: OENaPro;
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 160%;
  /* identical to box height, or 32px */

  letter-spacing: 0.03em;

  /* primary/black */

  color: ${(p) => p.theme.colors.black};
`

const StyledSubText = styled.p`
  margin: 0;

  font-family: MazdaType, OENaPro, sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 150%;
  /* identical to box height, or 27px */

  /* primary/black */

  color: ${(p) => p.theme.colors.black};
`

const StyledHeader = styled.h2`
  font-family: OENaPro;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 140%;
  margin: 0;
  letter-spacing: 0.05em;

  color: ${(p) => p.theme.colors.black};
  margin-bottom: 10px;
`

type Props = {
  item: RecallData
  type: ContentItemType
  length: number
}

const recallFields = {
  licenseNumber: "מספר רכב",
  chassisNumber: "מספר שילדה",
  id: "מספר קריאה",
  shortName: "שם קצר",
}

const warrantyFields = {
  licenseNumber: "מספר רכב",
  chassisNumber: "מספר שילדה",
  id: "מספר קריאה",
  phenomenonDesc: "שם קצר",
}

const colorFields = {
  licenseNumber: "מספר רכב",
  colorCode: "קוד צבע",
  colorName: "תיאור צבע",
}

const RecallItem = ({ item, type, length }: Props) => {
  const fieldsToMap =
    type === ContentItemType.COLOR
      ? colorFields
      : type === ContentItemType.WARRANTYEXTENSION
      ? warrantyFields
      : recallFields

  return (
    <Box>
      {length > 1 && <StyledHeader> קריאה מספר {item.numberCol}</StyledHeader>}
      <StyledItem $hasBorder={type !== ContentItemType.COLOR}>
        <StyledResponse $columns={type === ContentItemType.COLOR ? 3 : 2}>
          {Object.keys(fieldsToMap).map((it, index) => (
            <StyledTextContainer key={index.toString()}>
              <StyledTopText>{fieldsToMap[it]}:</StyledTopText>
              <StyledSubText>{item[it]}</StyledSubText>
            </StyledTextContainer>
          ))}
        </StyledResponse>
        {type !== ContentItemType.COLOR ? (
          <Box>
            <Box>מהות הקריאה</Box>
            <Box>{item.description}</Box>
          </Box>
        ) : null}
      </StyledItem>
    </Box>
  )
}

export default RecallItem
